import e from "./TooltipWrapper_vue.js";
//#region src/components/ui/tooltip/wrapper/TooltipWrapper.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=TooltipWrapper.js.map